export default __webpack_public_path__ + "static/media/Zhou_Danjin.224135a9.webp";